"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrl = void 0;
var createUrl = function (brand, model, generationName) {
    return "brand_name=".concat(brand, "&model_name=").concat(model, "&generation_name=").concat(generationName);
};
exports.createUrl = createUrl;
